import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';

import {
  HISTORY_KEY_SEARCH_VIDEO,
  LIST_TYPE,
  SearchParam,
  CITY2_INFO_LIST, expandCollapse, DEFAULT_SCROLL_SPEED
} from '../../shared/defines/client.const';
import {IsEmptyString} from '../../shared/defines/common.func';
import {makeImageUrl} from '../../shared/defines/client.func';
import {NormalizeSearchParamKeyword} from '../../shared/defines/search-keyword.func';
import {CITY2, CITY2_DEFAULT, isCity2Type} from '../../shared/defines/gukeo.const';
import {Video, VideoStory} from '../../shared/models/video.model';
import {VideoService} from '../../shared/services/video/video.service';
import {VideoBookmarkService} from '../../shared/services/video/video-bookmark.service';
import {LayoutMgrService} from '../../shared/services/layout-mgr/layout-mgr.service';
import {ScrollDownService} from "../../shared/services/scroll-down/scroll-down.service";
import {FOOTER_ON} from '../../shared/components/footer/footer.component';

@Component({
  selector: 'app-dialect-movie',
  templateUrl: './dialect-movie.component.html',
  styleUrls: ['./dialect-movie.component.scss'],
  animations: [expandCollapse]
})
export class DialectMovieComponent implements OnInit, OnDestroy {
  @ViewChild('container') container: ElementRef;

  public readonly FOOTER_ON = FOOTER_ON;
  public readonly HISTORY_KEY_SEARCH_VIDEO = HISTORY_KEY_SEARCH_VIDEO;
  public readonly CITY2_INFO_LIST = CITY2_INFO_LIST;
  protected readonly makeImageUrl = makeImageUrl;

  // 추가: API 로 받아온 도시 목록 저장 변수
  public availableCities: CITY2[] = [];

  private inited = false; // 초기화 여부

  public selectedCity: CITY2 | null = null;
  public selectedStory: number | null = null;

  // 라우터에서 넣어주는 값. (TODO: 초기화에 유의해야 함)
  private queryParams: SearchParam | null = null;
  private queryParams$: Subscription = null;
  private routeParams$: Subscription = null;

  // 푸터의 아래로 내리기 버튼 구독
  private scrollDown$: Subscription | null = null;

  public listStory: VideoStory[] | null = null;

  private loading$: Subscription = null;
  public listVideo: Array<Video> = null;

  protected sendingBookmark = false;

  public get isEmpty(): boolean {
    return !this.loading$ && this.listVideo.length === 0;
  }

  public get isLoading(): boolean {
    return this.loading$ !== null;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    protected sanitizer: DomSanitizer,
    private videoSvc: VideoService,
    private bmSvc: VideoBookmarkService,
    private scrollDownSvc: ScrollDownService,
    // private naviSvc: NavigationService,
    public lm: LayoutMgrService,
  ) {
    /******************************************************************************************
     * 라우터 파리미터 변경 핸들러 - 주소 뒤의 파라미터를 받아오는 곳. ( ?keyword=... )
     * 입력된 파라미터가 없어도 처음 초기화 할 때에도 불려진다.
     * 처음 화면에 들어올 때, 라우터 주소 변견 핸들러보다 더 먼저 불려진다. (이상하지만 그렇다)
     *
     * router.navigate()로 같은 주소를 호출하면 이 코드가 다시 불려진다.
     */
    this.queryParams$ = this.route.queryParams
      .subscribe(params => {
        this.queryParams = {};
        console.log('DialectMovieComponent::queryParams =', params);

        if ('city' in params) {
          const city2: CITY2 = params.city;
          if (isCity2Type(city2)) {
            this.selectedCity = city2;
          }
          else {
            console.error('DialectListComponent::constructor() invalid city =', params.city);
            this.selectedCity = CITY2_DEFAULT;
          }

          this.selectedStory = null;
        }
        else if ('story' in params) {
          this.selectedStory = parseInt(params.story, 10);

          this.selectedCity = null;
        }
        else {
          this.selectedCity = null;
          this.selectedStory = null;
        }

        this.queryParams = {
          ...('city' in params ? {city: this.selectedCity} : {}),
          ...('story' in params ? {story: this.selectedStory} : {}),
        };

        if (this.inited) {
          this.init();
        }
      });

    /******************************************************************************************
     * 라우터 주소 변경 핸들러 - 라우터 주소 읽어오는 곳.
     *
     * 라우터 주소에 포함된 파라미터가 변경되어도 불려진다.
     * queryParams가 바뀐 것(주소뒤의 ? 이후 파리미터)으로는 여기가 불려지지 않는다.
     */
    this.routeParams$ = route.params.subscribe(params => {
      console.log('DialectMovieComponent::params =', params, this.queryParams);

      this.init();
      this.inited = true;
    });

    this.loading$ = this.videoSvc.GetStoryList().subscribe((listStory: VideoStory[]) => {
      this.listStory = listStory;
    });
  }

  ngOnInit(): void {
    // 푸터의 스크롤 버튼 처리.
    this.scrollDown$ = this.scrollDownSvc.pushScrollDown$().subscribe(isFirst => {
      const scrollDelta = DEFAULT_SCROLL_SPEED * (isFirst ? 2 : 1);  // 스크롤 시작할 때 첫번째는 두배로 스크롤 함.

      this.container?.nativeElement.scrollTo({
        top: this.container.nativeElement.scrollTop + scrollDelta,
        behavior: 'auto',
      });
    });

    // 추가: API로 도시 목록 가져오기
    this.videoSvc.GetCityList().subscribe((cities: CITY2[]) => {
      this.availableCities = cities;
      console.log('DialectMovieComponent::GetCityList() availableCities =', this.availableCities);
    });
  }

  ngOnDestroy() {
    this.lm.CloseYoutubePopup();

    if (this.loading$) {
      this.loading$.unsubscribe();
      this.loading$ = null;
    }
    if (this.queryParams$) {
      this.queryParams$.unsubscribe();
      this.queryParams$ = null;
    }
    if (this.routeParams$) {
      this.routeParams$.unsubscribe();
      this.routeParams$ = null;
    }

    this.scrollDownSvc.popScrollDown$();
    if (this.scrollDown$) {
      this.scrollDown$.unsubscribe();
      this.scrollDown$ = null;
    }
  }

  /**
   * 저장된 searchParam(라우팅에서 전달받은 옵션)을 이용해서 페이지를 재 초기화하고 다시 로딩한다.
   */
  private init(): void {
    console.warn('DialectMovieComponent::init()', this.queryParams);

    const param: SearchParam = {
      ...('story' in this.queryParams ? {story: this.queryParams.story} : {story: 'all'}),
      ...(('city' in this.queryParams && this.queryParams.city !== '전국') ? {city: this.queryParams.city} : {}),
    };

    this.ReloadList(param);
  }

  private ReloadList(param?: SearchParam): void {
    if (this.loading$) {
      this.loading$.unsubscribe();
      this.loading$ = null;
    }

    this.loading$ = this.videoSvc.GetList(param).pipe(
      finalize(() => this.loading$ = null),
    ).subscribe((listVideo) => {
      this.listVideo = listVideo;
    });
  }


  /****************************************************************************
   * 이벤트 처리
   ****************************************************************************/


  public onGoHistory(): void {
    const queryParams = {l: LIST_TYPE.HISTORY};
    this.router.navigate(['/movie-search'], {queryParams}).then();
  }

  public SearchVideo(param: SearchParam): void {
    // console.log('MovieSearchComponent::ReloadList() param =', param);

    param = NormalizeSearchParamKeyword(param);
    if (!IsEmptyString(param.keyword)) {
      const queryParams = {
        keyword: param.keyword,
        l: LIST_TYPE.SERVER,
      };
      this.router.navigate(['/movie-search'], {queryParams}).then();
    }
  }


  protected onChangeCity($event: MouseEvent, city2: CITY2): void {
    console.warn('DialectMenuComponent.onChangeCity()', city2);
    $event.preventDefault();
    $event.stopPropagation();

    if (this.selectedCity !== city2) {
      this.selectedCity = city2;

      const queryParams: SearchParam = {
        city: city2,
      };
      this.router.navigate(['/dialect-movie'], { queryParams }).then();
    }
  }

  protected onSelectStory($event: MouseEvent, story: VideoStory): void {
    console.log('DialectMenuComponent.onSelectStory()', $event);
    $event.preventDefault();
    $event.stopPropagation();

    if (this.selectedStory !== story.no) {
      const queryParams: SearchParam = {
        story: story.no,
      };
      this.router.navigate(['/dialect-movie'], {queryParams}).then();
    }
  }

  public ToggleBookmark(video: Video): void {
    if (this.sendingBookmark) {
      return;
    }
    this.sendingBookmark = true;

    video.bookmark = !video.bookmark;
    this.bmSvc.sendBookmark(video.no, video.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe(
      data => console.log(data),
      err => console.error(err)
    );
  }

  /**
   * 주어진 도시가 off 되어야 하는지 결정합니다.
   * - '전국'인 경우는 항상 false.
   * - API에서 받아온 도시 목록(availableCities)에 존재하면 false, 없으면 true.
   */
  public isCityOff(city: CITY2): boolean {
    if (city === '전국') {
      return false;
    }
    // availableCities가 아직 로딩되지 않은 경우 기본 false (클래스 off를 적용하지 않음)
    if (!this.availableCities || this.availableCities.length === 0) {
      return false;
    }
    // API로 받아온 도시 목록에 해당 도시가 없으면 off 적용
    return this.availableCities.indexOf(city) === -1;
  }
}
